// extracted by mini-css-extract-plugin
export default {"settingsModal":"PlayerControlsModal_settingsModal__I810K","faToggle":"PlayerControlsModal_faToggle__6mpND"};